export const MissionVI = {
  "reasonMission": {
    "title": "Lý do công tác",
    "breadCrumb": "Quản lý lý do công tác",
    "pageHeader": {
      "reasonMission": "Quản lý lý do công tác"
    }
  }
}
